import React, { useState, useEffect } from "react";
import { Upload, Button, Input, Modal } from "antd";
import { PlusOutlined, DeleteRowOutlined, UploadOutlined } from "@ant-design/icons";
import axios from "axios";
import api from "../../config.json";
import swal from "sweetalert";
import Table from '../../Common/table'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import imageCompression from "browser-image-compression";

const MultipleImageUpload = ({ Heading }) => {
  const [fileList, setFileList] = useState([]);
  const [uploadList, setUploadList] = useState([]);
  const [remarks, setRemarks] = useState({}); // Track remarks for each image
  const [open, setOpen] = useState(false)



  useEffect(() => {
    Heading('Check Sheet Image Master')
    getAllImages()

  }, [])

  // Handling the file change
  const handleChange = ({ fileList: newFileList }) => {
    newFileList.forEach((one, idx) => {
      newFileList[idx] = one.originFileObj
    })
    setFileList(newFileList);
  };

  function changeFileName(originalFile, newFileName) {
    // Extract the extension from the original file name
    const originalExtension = originalFile.name.split('.').pop();

    // Check if the new file name already contains an extension
    if (!newFileName.includes('.')) {
      // Append the original file extension if not already provided
      newFileName = `${newFileName}.${originalExtension}`;
    }

    // Create a new File object with the same content and the new name
    const newFile = new File([originalFile], newFileName, {
      type: originalFile.type,
      lastModified: originalFile.lastModified,
    });

    return newFile;
  }


  // Handle remark change for each file
  const handleRemarkChange = (event, index) => {
    const files = [...fileList]
    files[index] = changeFileName(files[index], event.target.value)
    setFileList(files);
  };

  // Function to preview the uploaded image
  const handlePreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const imgWindow = window.open(src);
    imgWindow.document.write(`<img src='${src}' style='width:100%' />`);
  };

  // Function to handle image upload using Axios
  // const handleUpload = () => {
  //   const formData1 = new FormData();
  //   console.log(`Uploading`, fileList,formData1)
  //   fileList.map(file =>{
  //     let filesize =(file.size /100)
  //     if(filesize > 512){
  //     alert('Need To Compress Image Files')
  //     }else{

  //     }
  //   })
  //   return
  //   fileList.forEach((file) => {
  //     formData1.append("files", file);
  //   });

  //   axios
  //     .post(api.api + "uploadImage", formData1, {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //       },
  //     })
  //     .then((result) => {
  //       swal("Save Successfully");
  //       getAllImages();
  //       setOpen(false)
  //     })
  //     .catch((err) => {
  //       if (err.response && err.response.data) {
  //         swal("ERROR",`${err.response.data}`, { dangerMode: true });
  //       } else {
  //         swal(`${err}`);
  //       }
  //     });
  // };
  const handleUpload = async () => {
    const formData1 = new FormData();
    console.log(`Uploading`, fileList, formData1);
  
    // Check for files that exceed the size limit
    const largeFiles = fileList.filter(file => file.size / 1024 > 512); // convert bytes to KB
  
    // Function to compress images
    const compressImage = async (file) => {
      const options = {
        maxSizeMB: 0.5, // Compress to a maximum size of 512KB
        maxWidthOrHeight: 1920, // Maintain reasonable dimensions
        useWebWorker: true,
      };
      try {
        const compressedFile = await imageCompression(file, options);
        return compressedFile;
      } catch (error) {
        console.error("Error compressing image:", error);
        return file; // Return original file if compression fails
      }
    };
  
    if (largeFiles.length > 0) {
      // Open Ant Design Modal for confirmation if there are large files
      Modal.confirm({
        title: "Large File Detected",
        content: "Some files exceed 512KB. Would you like to compress them automatically?",
        async onOk() {
          // Compress large files before uploading
          for (const file of fileList) {
            const compressedFile = file.size / 1024 > 512 ? await compressImage(file) : file;
            formData1.append("files", compressedFile);
          }
          uploadImages(formData1);
        },
        onCancel() {
          swal("Upload Cancelled", "The upload was cancelled as files exceeded the size limit.", "info");
        },
      });
    } else {
      // Directly proceed if no files exceed the size limit
      fileList.forEach((file) => formData1.append("files", file));
      uploadImages(formData1);
    }
  };
  
  const uploadImages = (formData) => {
    axios
      .post(api.api + "uploadImage", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((result) => {
        swal("Save Successfully");
        getAllImages();
        setOpen(false);
      })
      .catch((err) => {
        if (err.response && err.response.data) {
          swal("ERROR", `${err.response.data}`, { dangerMode: true });
        } else {
          swal(`${err}`);
        }
      });
  };

  const getAllImages = () => {
    axios.get(api.api + 'uploadImage')
      .then((result) => {
        console.log(result.data, "hvhfvdhfs");
        setUploadList(result.data)
      })
      .catch((err) => {
        console.log(err);
      })

  }

  const handleRemove = (idx) => setFileList(fileList.filter((file, i) => i !== idx))
  
  const handleDeleteFile=(one)=>{
    axios.delete(api.api + 'uploadImage/'+one._id)
    .then((result) => {
     getAllImages()
    })
    .catch((err) => {
      console.log(err);
    })
  }

  const onDelete = (data) => {
    swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this",
        icon: "warning",
        buttons: true,
        dangerMode: true
    }).then(willDelete => {
        if (willDelete) {
            axios
                .delete(api.api + "uploadImage/" + data._id, { data: data })
                .then(result => {
                    // consol(result.data)
                    if (result.data.ok === 1 && result.data.deletedCount === 1) {
                        getAllImages();
                    }
                })
                .catch(err => {
                    if (err.response && err.response.data) {
                        swal(`${err.response.data.message}`);
                    } else {
                        swal(`${err}`);
                    }

                });
        } 
    });
}


  return (
    <div>
      {/* Upload Section */}
      <div style={{ width: 150, marginRight: 25 }} className="row text-right justify-content-end float-right mt-2 mb-2">
        <Button onClick={() => setOpen(true)} icon={<UploadOutlined />}>Click to Upload</Button>

      </div>

      {/* Display table for image previews with remarks */}
      <div className="table-responsive mt-4">
        <table className="table table-sm">
          <thead>
            <tr>
              <th scope="col">Image</th>
              <th scope="col">Image Name</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            {uploadList.map(one => {
              return <tr>
                <td><img src={one.FilePath} alt="Preview 1" className="img-thumbnail" style={{ width: '50px' }} /></td>
                <td>{one.DocTitle}</td>
                <td><FontAwesomeIcon onClick={()=>onDelete(one)} color="red" icon={faTrashAlt}/></td>
              </tr>
            })}
          </tbody>
        </table>
      </div>

      <Modal
        title="Upload Images"
        centered
        open={open}
        onCancel={() => setOpen(false)}
        footer={[
          <button key="cancel" className="btn btn-secondary  mr-2" onClick={() => setOpen(false)}>
            Cancel
          </button>,
          <button key="submit" className="btn btn-primary" onClick={handleUpload}>
            Submit
          </button>,
        ]}
        width={"90%"}
      >
        <div id="customers" className="p-1 w-100">
          <div className="row text-right justify-content-end">
            <Upload
              showUploadList={false}
              className="align-text-bottom mt-4"
              onChange={handleChange}
              onPreview={handlePreview}
              beforeUpload={() => false} // Prevent auto-upload
              multiple
            >
              <Button icon={<UploadOutlined />}>Upload Images</Button>
            </Upload>
          </div>

          {/* Display table for image previews with remarks */}
          <div className="table-responsive mt-4">
            <table className="table table-sm">
              <thead>
                <tr>
                  <th scope="col">Image</th>
                  <th scope="col">Image Name</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {fileList.map((one, idx) => {
                  return <tr>
                    <td><img src={URL.createObjectURL(one)} alt="Preview 1" className="img-thumbnail" style={{ width: '50px', height: 50 }} height={50} /></td>
                    <td><input placeholder="Enter name of image you want to show" className="form-control form-control-sm" type="text" onChange={(e) => handleRemarkChange(e, idx)} /></td>
                    <td><Button onClick={() => handleRemove(idx)} type="link">Remove</Button></td>
                  </tr>
                })}
              </tbody>
            </table>
          </div>
        </div>
      </Modal>


      {/* Save Changes Button */}
      {/* <div className="text-right">
        <Button type="primary" onClick={handleUpload} style={{ marginTop: 16 }}>
          Save Changes
        </Button>
      </div> */}
    </div>
  );
};

export default MultipleImageUpload;
